import React from 'react';
import { CreateEditItemPanels } from 'sharedMenuItems/pages/createEditItem/components/createEditItemPanels/CreateEditItemPanels';

export const CreateItemPage = () => {
  return <CreateEditItemPanels />;
};
